import React from 'react'

import ProductDetails from './ProductDetails'
import Totals from './Totals'
import HubDiscount from './HubDiscount'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import SpringSaleDisclaimer from './SpringSaleDisclaimer'
import VatForm from './VatForm'
import { type WebCart, type WebCustomer2 } from '../../common/types/webshop.types'
import MoneyBackGuaranteeBadge from '../../common/components/MoneyBackGuaranteeBadge'

type Props = {
    order: WebCart,
    customer: WebCustomer2,
    isBfxd?: boolean
    isPaylink?: boolean
}

export default function Summary({ order, customer, isBfxd=false, isPaylink=false }: Props) {
    const queryClient = useQueryClient();
    const { t } = useTranslation('common', {keyPrefix: 'purchase'});

    const handleDiscountSave = () => {
        queryClient.invalidateQueries({queryKey: ['checkout']})
    }

    return (
        <div className='summary-container'>
            {!isPaylink && (
                <h2 className='checkout-header'>{t('summary')}</h2>
            )}
            <ProductDetails order={order} isBfxd={isBfxd} />
            <HubDiscount order={order} customer={customer} onSave={handleDiscountSave} />
            <VatForm customer={customer} />
            <div>
            <Totals order={order} />
            </div>
            {!isPaylink && (
                <div style={{marginLeft: 'auto'}}>
                    <MoneyBackGuaranteeBadge />
                </div>
            )}
        </div>
    )
}
